var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.deliveryType == 'regular' ? _c('div', {
    staticClass: "pt-24px px-md-16px"
  }, [_c('v-card', {
    attrs: {
      "color": "primary lighten-4",
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "px-12px py-16px pa-md-8px"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs font-weight-medium primary--text text--darken-4"
  }, [_vm._v("배송주기")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-select', _vm._b({
    model: {
      value: _vm.deliveryCycle,
      callback: function ($$v) {
        _vm.deliveryCycle = $$v;
      },
      expression: "deliveryCycle"
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input, {
    items: _vm.items,
    style: _vm.$vuetify.breakpoint.lgAndUp ? 'width: 500px' : ''
  }), false))], 1)], 1)], 1)])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }